import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import AgronomyAgreementServicesContext from './AgronomyAgreementServicesContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const AgronomyAgreementServicesProvider: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <AgronomyAgreementServicesContext.Provider value={{ actions, selectors, state }}>
      {children}
    </AgronomyAgreementServicesContext.Provider>
  );
};

export default AgronomyAgreementServicesProvider;
